<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "Container",
  created() {
    if (this.$store.state.user.match) {
      this.$router.push({
        name: "Home",
      });
    }
  },
};
</script>
